// extracted by mini-css-extract-plugin
export var container = "PostList-module--container--HS0Sb";